// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Statistics_percentageContainer__Xx1h\\+ {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0 2rem 4rem;
  box-sizing: border-box;
  height: auto !important;
  min-height: auto !important;
  overflow: visible !important;
}

.Multiboard,
.Multiboard__flex,
.Multiboard__main {
  height: auto !important;
  min-height: auto !important;
  overflow: visible !important;
}

.statBoard {
  width: 100% !important;
  max-width: 140rem !important;
  margin: 0 auto !important;
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  grid-auto-rows: 38rem !important;
  gap: 1rem !important;
  align-content: start !important;
  justify-content: start !important;
  justify-items: stretch !important;
  position: relative;
  z-index: 1;
}

.statBoard__cell {
  flex: initial !important;
  width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
}

.statCard.statCard--board.card {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  padding: 0.75rem !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}

.statCard.statCard--board.card .barChartTitleContainer *,
.statCard.statCard--board.card .pieChartTitleContainer * {
  padding-left: 0 !important;
  margin-left: 0 !important;
  text-indent: 0 !important;
}

.statCard button,
.statCard a {
  text-decoration: none !important;
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.statCard button::after,
.statCard a::after,
.statCard button::before,
.statCard a::before {
  display: none !important;
  content: none !important;
}


.Multiboard {
  height: auto !important;
  min-height: auto !important;
  overflow: visible !important;
}

@media (max-width: 120rem) {
  .statBoard {
    max-width: 160rem !important;
  }
}
@media (max-width: 48rem) {
  .statBoard {
    grid-template-columns: 1fr !important;
    max-width: 40rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Statistics/Statistics.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,2DAA2D;EAC3D,gCAAgC;EAChC,oBAAoB;EACpB,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;;;EAIE,wBAAwB;EACxB,wBAAwB;AAC1B;;;AAGA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,qCAAqC;IACrC,2BAA2B;EAC7B;AACF","sourcesContent":[".percentageContainer {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin: 0;\r\n  padding: 0 2rem 4rem;\r\n  box-sizing: border-box;\r\n  height: auto !important;\r\n  min-height: auto !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n:global(.Multiboard),\r\n:global(.Multiboard__flex),\r\n:global(.Multiboard__main) {\r\n  height: auto !important;\r\n  min-height: auto !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n:global(.statBoard) {\r\n  width: 100% !important;\r\n  max-width: 140rem !important;\r\n  margin: 0 auto !important;\r\n  display: grid !important;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\r\n  grid-auto-rows: 38rem !important;\r\n  gap: 1rem !important;\r\n  align-content: start !important;\r\n  justify-content: start !important;\r\n  justify-items: stretch !important;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n:global(.statBoard__cell) {\r\n  flex: initial !important;\r\n  width: 100% !important;\r\n  min-width: 0 !important;\r\n  height: auto !important;\r\n}\r\n\r\n:global(.statCard.statCard--board.card) {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  min-height: 0 !important;\r\n  padding: 0.75rem !important;\r\n  box-sizing: border-box !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n:global(.statCard.statCard--board.card .barChartTitleContainer *),\r\n:global(.statCard.statCard--board.card .pieChartTitleContainer *) {\r\n  padding-left: 0 !important;\r\n  margin-left: 0 !important;\r\n  text-indent: 0 !important;\r\n}\r\n\r\n:global(.statCard button),\r\n:global(.statCard a) {\r\n  text-decoration: none !important;\r\n  border: none !important;\r\n  border-bottom: none !important;\r\n  box-shadow: none !important;\r\n  background: transparent !important;\r\n}\r\n\r\n:global(.statCard button::after),\r\n:global(.statCard a::after),\r\n:global(.statCard button::before),\r\n:global(.statCard a::before) {\r\n  display: none !important;\r\n  content: none !important;\r\n}\r\n\r\n\r\n:global(.Multiboard) {\r\n  height: auto !important;\r\n  min-height: auto !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n@media (max-width: 120rem) {\r\n  :global(.statBoard) {\r\n    max-width: 160rem !important;\r\n  }\r\n}\r\n@media (max-width: 48rem) {\r\n  :global(.statBoard) {\r\n    grid-template-columns: 1fr !important;\r\n    max-width: 40rem !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"percentageContainer": `Statistics_percentageContainer__Xx1h+`
};
export default ___CSS_LOADER_EXPORT___;
